module.exports = __webpack_public_path__ + "static/Caroline-179397b3273db4272751f5928c161d6d.jpg";